<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-card class="elevation-6" :width="isRegisterForm ? 520 : 400">
            <v-toolbar dark color="primary" class="justify-center">
              <v-toolbar-title
                >{{ $city.name }}政府健檢預約平台</v-toolbar-title
              >
            </v-toolbar>
            <v-card-text>
              <v-text-field
                v-model="formInput.account"
                prepend-icon="mdi-account"
                label="帳號"
                type="text"
                v-on:keyup.enter="doAction"
              ></v-text-field>
              <v-text-field
                v-if="isLoginForm"
                v-model="formInput.password"
                prepend-icon="mdi-lock"
                label="密碼"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                v-on:keyup.enter="doAction"
              ></v-text-field>
              <v-text-field
                v-if="isForgetForm"
                v-model="formInput.email"
                prepend-icon="mdi-mail"
                label="Email"
                v-on:keyup.enter="doAction"
              ></v-text-field>
              <template v-if="isRegisterForm">
                <v-text-field
                  v-model="formInput.name"
                  prepend-icon="mdi-account-card-details"
                  label="姓名"
                  v-on:keyup.enter="doAction"
                ></v-text-field>
                <v-text-field
                  v-model="formInput.email"
                  prepend-icon="mdi-mail"
                  label="Email"
                  v-on:keyup.enter="doAction"
                ></v-text-field>
                <v-text-field
                  v-model="formInput.phone"
                  prepend-icon="mdi-phone"
                  label="聯絡電話"
                  v-on:keyup.enter="doAction"
                ></v-text-field>
                <v-text-field
                  v-model="formInput.organization"
                  prepend-icon="mdi-hospital-building"
                  label="醫事單位"
                  v-on:keyup.enter="doAction"
                ></v-text-field>
                <v-text-field
                  v-model="formInput.organizationCode"
                  prepend-icon="mdi-card-account-details"
                  label="醫事機構代碼"
                  v-on:keyup.enter="doAction"
                ></v-text-field>
                <v-select
                  v-model="formInput.district"
                  :items="districts"
                  label="行政區"
                  prepend-icon="mdi-map-marker"
                  clearable
                ></v-select>
                <v-textarea
                  v-model="formInput.reason"
                  label="申請原因"
                  rows="2"
                ></v-textarea>
              </template>

            </v-card-text>
            <v-card-actions>
              <v-btn
                v-if="isLoginForm"
                text
                color="primary"
                @click="switchMode('register')"
              >
                註冊
              </v-btn>
              <v-btn
                v-if="isLoginForm"
                text
                color="primary"
                @click="switchMode('forget')"
              >
                忘記密碼
              </v-btn>
              <v-btn
                v-if="!isLoginForm"
                text
                color="primary"
                @click="switchMode('login')"
              >
                返回登入
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="doAction"
              >
                {{ actionText }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import ls from "expired-localstorage";
import { 行政區 } from "@/libs/const";

export default {
  name: "Login",
  data: () => ({
    formInput: {
      account: "",
      password: "",
      email: "",
      name: "",
      phone: "",
      organization: "",
      organizationCode: "",
      district: "",
      reason: "",
    },
    showPassword: false,
    user: {},
    formMode: "login",
    districts: 行政區 || [],
  }),
  computed: {
    isLoginForm() {
      return this.formMode === "login";
    },
    isForgetForm() {
      return this.formMode === "forget";
    },
    isRegisterForm() {
      return this.formMode === "register";
    },
    actionText() {
      if (this.isLoginForm) return "登入";
      if (this.isForgetForm) return "重設";
      return "送出申請";
    },
  },
  methods: {
    switchMode(mode) {
      this.formMode = mode;
      this.formInput.password = "";
    },
    async doAction() {
      if (this.isLoginForm) {
        this.login();
      } else if (this.isForgetForm) {
        this.forget();
      } else {
        this.registerApply();
      }
    },

    async forget() {
      this.$vloading.show();
      if (this.formInput.account == "" || this.formInput.email == "") {
        this.$vloading.hide();
        this.$toast.error(
          "帳號、Email 不得為空，若無 Email 請聯絡管理者重設密碼",
        );
        return;
      }
      let data = (
        await this.axios.post("/dashboard/forget", {
          account: this.formInput.account,
          email: this.formInput.email,
        })
      ).data;
      this.$vloading.hide();
      if (!data) {
        this.$toast.error("帳號、Email 驗證錯誤！");
      } else {
        this.$toast.success("已寄出重設密碼信件，請查收");
        this.formInput.email = "";
        this.formInput.password = "";
        this.switchMode("login");
      }
    },
    async registerApply() {
      const required = [
        { key: "account", label: "帳號" },
        { key: "name", label: "姓名" },
        { key: "email", label: "Email" },
      ];
      const missing = required.find((item) => !this.formInput[item.key]);
      if (missing) {
        this.$toast.error(`${missing.label}不得為空`);
        return;
      }
      this.$vloading.show();
      try {
        await this.axios.post("/dashboard/register-apply", this.formInput);
        this.$toast.success("申請已送出，待管理者審核");
        this.formInput = {
          account: "",
          password: "",
          email: "",
          name: "",
          phone: "",
          organization: "",
          organizationCode: "",
          district: "",
          reason: "",
        };
        this.switchMode("login");
      } catch (error) {
        this.$toast.error(error.response?.data?.errMsg || "申請送出失敗");
      } finally {
        this.$vloading.hide();
      }
    },
    async login() {
      try {
        this.$vloading.show();
        // 檢查基本欄位
        if (this.formInput.account == "" || this.formInput.password == "") {
          this.$vloading.hide();
          this.$toast.error("帳號、密碼不得為空");
          return;
        }

        // reCAPTCHA 暫停使用，沿用後端帳密、速率限制及鎖定驗證。
        let data = (
          await this.axios.post("/dashboard/login", {
            account: this.formInput.account,
            password: this.formInput.password,
          })
        ).data;
        this.$vloading.hide();
        if (!data) {
          this.$toast.error("帳號密碼錯誤！");
          ls.remove("token");
        } else {
          this.$store.commit("setState", {
            user: data.user,
            warningPWExired: null,
          });
          ls.set("token", data.token);
          if (data.user.角色 == "醫療院所") {
            window.location = "/dashboard/checkin";
          } else {
            window.location = "/dashboard/main";
          }
        }

        // if (user.角色 == "預約客服") {
        //   this.$store.commit("service", user);
        //   this.$router.push("/Service");
        // } else if (user.角色 == "NIIS") {
        //   this.$store.commit("service", user);
        //   this.$router.push("/Niis");
        // } else {
        //   this.$store.commit("login", user);
        //   this.$router.push("/Dashboard");
        // }
      } catch (error) {
        console.log(error);
        if (error.response?.data?.errMsg) {
          this.$toast.error(error.response.data.errMsg);
          this.formInput.password = "";
        } else {
          this.$toast.error("登入失敗，請稍後再試");
        }


        this.$vloading.hide();
      }
    },
  },
};
</script>
